
import { useState } from "react";
import { Label } from "@/components/ui/label";
import { ImagePlus } from "lucide-react";
import { ImageUpload } from "@/components/shared/ImageUpload";
import { ImageGallery } from "@/components/shared/ImageGallery";

interface PropertyMediaUploadProps {
  images: string[];
  onChange: (urls: string[]) => void;
}

export const PropertyMediaUpload = ({ images, onChange }: PropertyMediaUploadProps) => {
  const [propertyImages, setPropertyImages] = useState<string[]>(images);

  const handleImagesUploaded = (newUrls: string[]) => {
    const updatedImages = [...propertyImages];
    
    // Only add new URLs that don't already exist in the array
    newUrls.forEach(url => {
      if (!updatedImages.includes(url)) {
        updatedImages.push(url);
      }
    });
    
    setPropertyImages(updatedImages);
    onChange(updatedImages);
  };

  const handleImageRemove = (index: number) => {
    const updatedImages = [...propertyImages];
    updatedImages.splice(index, 1);
    setPropertyImages(updatedImages);
    onChange(updatedImages);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-4">
        <Label htmlFor="images">Property Images</Label>
        <ImagePlus className="h-4 w-4 text-muted-foreground" />
      </div>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div>
          <ImageUpload
            bucketName="property-media"
            currentImages={propertyImages}
            onUploadComplete={handleImagesUploaded}
            allowMultiple={true}
            maxFileSize={10}
            buttonText="Add Property Images"
            filePrefix="property-"
          />
          <p className="text-sm text-muted-foreground mt-2">
            Add high-quality images of your property. Upload multiple images to showcase different areas.
          </p>
        </div>
        
        <div>
          <ImageGallery 
            images={propertyImages}
            onRemove={handleImageRemove}
            allowRemove={true}
          />
        </div>
      </div>
    </div>
  );
};
